import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { accountEditResponseSchema, Permissions } from '../types';

export type EditAccountMutationParams = {
	id: number;
	name: string;
	note: string;
	permissions: Permissions;
};

export const createEditAccountMutation = () =>
	createAuthMutation({
		params: declareParams<EditAccountMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `/account/${id}`,
			body: ({ id, ...params }) => params,
		},
		response: {
			contract: zodContract(accountEditResponseSchema),
		},
	});

export const editAccountMutation = createEditAccountMutation();
